// src/routes/Rutas.jsx
import { useContext, useEffect } from "react";
import { UserContext } from "../Components/Context/Context";

import { Routes, Route, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "../Components/ProtectedRoute";
import PublicRoute from "../Components/PublicRoute";
// Contexto de usuario

// Componentes individuales
import Login from "../Login/Login";
import Perfil from "../Perfil/Perfil";
import Panel from "../Panel/Panel";

import Biblioteca from "../Biblioteca/Biblioteca";
import VerLibreria from "../Biblioteca/Crud/Ver";
import CrearLibreria from "../Biblioteca/Crud/Crear";
import EditarLibreria from "../Biblioteca/Crud/Editar";

import Contactos from "../Contactos/Contactos";
import CrearContacto from "../Contactos/Crud/Crear";
import EditarContacto from "../Contactos/Crud/Editar";
import VerContacto from "../Contactos/Crud/Ver";

import Clientes from "../Clientes/Clientes";
// import CrearCliente from "../Clientes/Crud/Crear";
import EditarCliente from "../Clientes/Crud/Editar";
import VerCliente from "../Clientes/Crud/Ver";

import Expedientes from "../Expedientes/Expedientes";
import VerExpediente from "../Expedientes/Crud/Ver";
import CrearExpediente from "../Expedientes/Crud/Crear";
import EditarExpediente from "../Expedientes/Crud/Editar";
import TransferirExpediente from "../Expedientes/Crud/Transferir";

// PUBLIC
import ClientSign from "../Expedientes/ClientSign/ClientSign";

import InformeGeneral from "../Informes/InformeGeneral";
import InformePorUsuario from "../InformePorUsuario";
import InformeLlamadas from "../InformeLlamadas";

import Empresas from "../ConfigDropdown/Empresas/Empresas";
import CompanyView from "../ConfigDropdown/Empresas/Ver";
import CreateCompany from "../ConfigDropdown/Empresas/Crear";
import EditEmpresas from "../ConfigDropdown/Empresas/Editar";

import Oficinas from "../ConfigDropdown/Oficinas/Oficinas";
import CrearOficina from "../ConfigDropdown/Oficinas/Crear";
import EditarOficina from "../ConfigDropdown/Oficinas/Editar";
import VerOficina from "../ConfigDropdown/Oficinas/Ver";

import Usuarios from "../ConfigDropdown/UsuariosCRM/Usuarios";
import VerUsuarios from "../ConfigDropdown/UsuariosCRM/Ver";
import CrearUsuario from "../ConfigDropdown/UsuariosCRM/Crear";
import EditarUsuario from "../ConfigDropdown/UsuariosCRM/Editar";

import Roles from "../ConfigDropdown/Roles/Roles";
import CrearTipoUsuario from "../ConfigDropdown/Roles/Crear";
import EditarTipoUsuario from "../ConfigDropdown/Roles/Editar";

import Asociaciones from "../ConfigDropdown/Asociaciones/Asociaciones";
import VerAsociacion from "../ConfigDropdown/Asociaciones/Ver";
import CrearAsociacion from "../ConfigDropdown/Asociaciones/Crear";
import EditarAsociacion from "../ConfigDropdown/Asociaciones/Editar";

import Grupos from "../ConfigDropdown/Grupos/Grupos";
import CrearGrupos from "../ConfigDropdown/Grupos/Crear";
import EditarGrupos from "../ConfigDropdown/Grupos/Editar";

// import Zonas from "../ConfigDropdown/Zonas/Zonas";
// import CrearZona from "../ConfigDropdown/Zonas/Crear";
// import EditarZona from "../ConfigDropdown/Zonas/Editar";

import Notifications from "../Notifications/Notifications";
import CreateNotifications from "../Notifications/Crud/CreateNotifications";
import EditNotifications from "../Notifications/Crud/EditNotifications";

import HojasDeEncargo from "../ConfigDropdown/HojasDeEncargo/HojasDeEncargo";
import CrearContrato from "../ConfigDropdown/HojasDeEncargo/Crud/Crear";
import EditarContrato from "../ConfigDropdown/HojasDeEncargo/Crud/Editar";
import VerContrato from "../ConfigDropdown/HojasDeEncargo/Crud/Ver";

// Tipos de casos
import TiposDeCasos from "../ConfigDropdown/TiposDeCasos/TiposDeCasos";
import EditarTipoDeCaso from "../ConfigDropdown/TiposDeCasos/Editar";
import CrearTipoDeCaso from "../ConfigDropdown/TiposDeCasos/Crear";
// import VerTipoDeCaso from "../ConfigDropdown/TiposDeCasos/Ver";

import Inbox from "../Mensajes/Mailbox";

import NotFoundPage from "../Components/Common/NotFoundPage";
import Layout from "../Components/Common/Layout";
import { DocsProvider } from "../Components/Context/DocsProvider";
import LoadingMainPage from "../Components/Common/Loading/LoadingMainPage"; // o tu loader preferido
import ChangePassword from "../Components/ChangePassword";
import { UserProvider } from "../Components/Context/UserProvider";
import { ClientsProvider } from "../Components/Context/ClientsProvider";
import Settings from "../ConfigDropdown/ExpedientesConfig/Settings";
import { useEcho } from "../Components/helpers/Echo/echo";

function Rutas() {
  // const { isLoading } = useUser();
  // if (isLoading) {
  //   return <LoadingMainPage isLoading={true} />; //  bloquea el render mientras carga
  // }

  useEcho();

  // Cuando ya exista userData, activamos el listener
  return (
    <Routes>
      {/* Rutas protegidas (IMPORTANTE: UserProvider ENVUELVE TODA EL ÁREA PROTEGIDA) */}

      {/* Rutas públicas */}
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ChangePassword />} />

      <Route element={<Layout />}>
        <Route element={<ProtectedRoute />}>
          <Route path="/panel" element={<Panel />} />
          <Route path="/mensajes" element={<Inbox />} />
          <Route path="/perfil" element={<Perfil />} />

          {/* Biblioteca */}
          <Route path="/biblioteca" element={<Biblioteca />} />
          <Route path="/biblioteca/ver" element={<VerLibreria />} />
          <Route path="/biblioteca/crear" element={<CrearLibreria />} />
          <Route path="/biblioteca/editar" element={<EditarLibreria />} />

          {/* Empresas */}
          <Route path="/empresas" element={<Empresas />} />
          <Route path="/empresas/ver" element={<CompanyView />} />
          <Route path="/empresas/crear" element={<CreateCompany />} />
          <Route path="/empresas/editar" element={<EditEmpresas />} />

          {/* <Route path="/despachos" element={<Oficinas />} />
          <Route path="/despachos/crear" element={<CrearOficina />} />
          <Route path="/despachos/editar" element={<EditarOficina />} />
          <Route path="/despachos/ver" element={<VerOficina />} /> */}

          {/* Clientes */}
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/clientes/editar" element={<EditarCliente />} />
          <Route path="/clientes/ver" element={<VerCliente />} />

          {/* Asociaciones y grupos */}
          <Route path="/asociaciones" element={<Asociaciones />} />
          <Route path="/asociaciones/ver" element={<VerAsociacion />} />
          <Route path="/asociaciones/crear" element={<CrearAsociacion />} />
          <Route path="/asociaciones/editar" element={<EditarAsociacion />} />

          <Route path="/grupos" element={<Grupos />} />
          <Route path="/grupos/crear" element={<CrearGrupos />} />
          <Route path="/grupos/editar" element={<EditarGrupos />} />

          {/* Usuarios */}
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/usuarios/ver" element={<VerUsuarios />} />
          <Route path="/usuarios/crear" element={<CrearUsuario />} />
          <Route path="/usuarios/editar" element={<EditarUsuario />} />

          {/* Contactos */}
          <Route path="/contactos" element={<Contactos />} />
          <Route path="/contactos/crear" element={<CrearContacto />} />
          <Route path="/contactos/editar" element={<EditarContacto />} />
          <Route path="/contactos/ver" element={<VerContacto />} />

          {/* Expedientes */}
          <Route path="/expedientes-config" element={<Settings />} />
          <Route path="/expedientes" element={<Expedientes />} />

          <Route
            path="/expedientes/ver"
            element={
              <DocsProvider>
                <VerExpediente />
              </DocsProvider>
            }
          />

          <Route path="/expedientes/crear" element={<CrearExpediente />} />
          <Route path="/expedientes/editar" element={<EditarExpediente />} />
          <Route
            path="/expedientes/transferir"
            element={<TransferirExpediente />}
          />

          {/* Notificaciones */}
          <Route path="/notificaciones" element={<Notifications />} />
          <Route
            path="/notificaciones/crear"
            element={<CreateNotifications />}
          />
          <Route
            path="/notificaciones/editar"
            element={<EditNotifications />}
          />

          {/* Informes */}
          <Route
            path="/informes/informe-general"
            element={<InformeGeneral />}
          />
          <Route
            path="/informes/informe-por-usuario"
            element={<InformePorUsuario />}
          />
          <Route
            path="/informes/informe-llamadas"
            element={<InformeLlamadas />}
          />

          {/* Configuración */}
          {/* Roles  */}
          <Route path="/roles" element={<Roles />} />
          <Route path="/roles/crear" element={<CrearTipoUsuario />} />
          <Route path="/roles/editar" element={<EditarTipoUsuario />} />
          {/* Hojas de encargo  */}
          <Route path="/contratos" element={<HojasDeEncargo />} />
          <Route path="/contratos/crear" element={<CrearContrato />} />
          <Route path="/contratos/editar" element={<EditarContrato />} />
          <Route path="/contratos/ver" element={<VerContrato />} />
          {/* Tipos de casos  */}
          <Route path="/tiposdecasos" element={<TiposDeCasos />} />
          <Route path="/tiposdecasos/editar" element={<EditarTipoDeCaso />} />
          <Route path="/tiposdecasos/crear" element={<CrearTipoDeCaso />} />
          {/* <Route path="/tiposdecasos/ver" element={<VerTipoDeCaso />} /> */}
          {/* Configuración */}
        </Route>
      </Route>

      {/* CATCH-ALL */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default Rutas;
